export const stepTypes = {
  FORM: "FORM",
  RECEIPT: "RECEIPT",
  REVIEW: "REVIEW"
};

export const MAX_FILES_SIZE = 10485760;
